// import logo from './logo.svg';
import logo from '../assets/BDSA_clear.png';
import styles from './Home.module.css';
import { Centered } from '../layouts/Base';
import { Link } from 'react-router-dom';
import NetworkDiagram from '../components/network/NetworkDiagram';
import NetworkDescription from '../components/network/NetworkDescription';
import { isPdsaMode } from '../utils/appBranding';
import PdsaHome from './PdsaHome';
import { DATA_MANAGER_HOME, DATA_MANAGER_WORKSPACE_LABEL } from '../constants/setupRoadmapSteps';

function BdsaHome() {
  const scrollToNetwork = () => {
    const networkDiagram = document.getElementById('network-diagram');
    if (networkDiagram) {
      networkDiagram.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <Centered>
      <div className={styles.Home}>
        
          <h1>Welcome to the BDSA <img src={logo} className={styles["App-logo"]} alt="logo" /></h1>
          <NetworkDescription onViewNetwork={scrollToNetwork} />
          <h3>View BDSA Slides</h3>
          <ul className={styles.viewSlidesList}>
            <li><Link to="/collections">View All Collections</Link></li>
            <li><Link to="/bdsa/items">Browse all BDSA items (table)</Link></li>
          </ul>
          <h3>Projects</h3>
          <ul>
            <li><Link to="/projects">Manage annotation projects</Link></li>
          </ul>
          <h3>Data Managers</h3>
          <ul>
            <li><Link to={DATA_MANAGER_HOME}>{DATA_MANAGER_WORKSPACE_LABEL} (login required)</Link></li>
          </ul>
          <h3>Administrators: Configure the BDSA</h3>
          <ul>
            <div><Link to='/admin'>Admin homepage (login required)</Link></div>
          </ul>
          <h3>Services</h3>
          <ul>
            <li><a href='/dsa'>Access the Digital Slide Archive (Girder) service</a></li>
            <li><a href='/dsa/api/v1'>Access the Girder REST API</a></li>
            <li><a href='/mongodb'>Access the read-only mongo-express service</a></li>
          </ul>
          <h3>Development</h3>
          <p>
            Edit files in <code>/services/react</code> and save to reload.
          </p>
          
          <div id="network-diagram">
            <NetworkDiagram />
          </div>
      
      </div>
    </Centered>
  );
}

function Home() {
  if (isPdsaMode()) {
    return <PdsaHome />;
  }
  return <BdsaHome />;
}

export default Home;
